import { IProcessedOrders } from "../constants";

export const SET_ORDERS = "SET_ORDERS";

export function setOrders(orderList: IProcessedOrders[]) {
    return {
        type: SET_ORDERS,
        payload: orderList
    }
}

export const SET_TAB = "SET_TAB";

export function setTab(tab: string) {
    return {
        type: SET_TAB,
        payload: tab
    }
}

export const SET_FILTER_STATE = "SET_FILTER_STATE";

export function setFilterState(filterObj: any) {
    return {
        type: SET_FILTER_STATE,
        payload: filterObj
    }
}

export const SET_FILTER_CRITERIA = "SET_FILTER_CRITERIA";

export function setFilterCriteria(criteria: any) {
    return {
        type: SET_FILTER_CRITERIA,
        payload: criteria
    }
}

export const SET_COLLECTION_POINTS = "SET_COLLECTION_POINTS";

export function setCollectionPoints(collectionPoints: any[]) {
    return {
        type: SET_COLLECTION_POINTS,
        payload: collectionPoints
    }
}